var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-sign-sale-modal-base", {
    attrs: { sale: _vm.sale },
    on: { save: _vm.doConfirm, close: _vm.close },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }